export default __webpack_public_path__ + "static/media/post12.76401dd4.png";